import { LightbulbFilamentIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Alert, Flex, Input, Typography } from "antd";

export function ProjectSettingsFormBrief<T>(
  props: Readonly<{
    value: T | undefined;
    onChange: (value: T) => void;
  }>
) {
  const t = useTranslate();
  return (
    <Flex vertical gap={60}>
      <Input.TextArea
        value={props.value as string}
        onChange={(e) => props.onChange(e.target.value as T)}
        rows={4}
      />
      <Alert
        type="info"
        showIcon
        icon={<LightbulbFilamentIcon size={40} />}
        description={
          <Flex vertical gap={10}>
            <Typography.Text>
              {t("projects.components.ProjectSettingForm.example")}
            </Typography.Text>
            <Typography.Text type="secondary" copyable>
              {t("projects.components.ProjectSettingForm.weWantTo")}
            </Typography.Text>
          </Flex>
        }
      />
    </Flex>
  );
}
